module.exports = __webpack_public_path__ + "static/media/whyharbor-img2.f855a834.svg";